import { render, staticRenderFns } from "./achemicals.vue?vue&type=template&id=cfd5c27c&"
import script from "./achemicals.vue?vue&type=script&lang=js&"
export * from "./achemicals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports